import { datadogRum, DefaultPrivacyLevel } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'
import { useLogger, isBooksyCom } from '@booksy-com/vue-tools'

import {
  shouldBeDiscardedFromLogs,
  shouldBeDiscardedFromRum,
  isBot,
} from './utils'

import pkg from '@/../package.json'

import {
  APPLICATION_ID,
  CLIENT_TOKEN,
  SITE,
  SERVICE,
} from './consts.ts'
import allowedTracingUrlsRegex from './utils/allowed-tracing-urls-regex.js'

const logger = useLogger('datadog')

const o = window.location.origin

export default {
  install (Vue, options) {
    const env = isBooksyCom()
      ? 'prod'
      : o.match(/booksy\.pm/)
        ? 'test'
        : 'other'

    if (!env.match(/(prod|test)/)) {
      logger.warn('skipping; reason: unknown environment')
      return
    }

    const rumConfig = {
      applicationId: APPLICATION_ID,
      clientToken: CLIENT_TOKEN,
      site: SITE,
      service: SERVICE,
      env,
      enableExperimentalFeatures: ['feature_flags'],
      version: pkg.version,
      sessionSampleRate: isBot() ? 0 : 100,
      sessionReplaySampleRate: 1,
      traceSampleRate: 5,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: DefaultPrivacyLevel.MASK_USER_INPUT,
      allowedTracingUrls: [
        {
          match: allowedTracingUrlsRegex,
          propagatorTypes: ['tracecontext'],
        },
      ],
      beforeSend: (event, context) => {
        if (shouldBeDiscardedFromRum(event, context)) {
          return false
        }

        return true
      },
    }

    const logConfig = {
      clientToken: CLIENT_TOKEN,
      site: SITE,
      service: SERVICE,
      env,
      version: pkg.version,
      forwardErrorsToLogs: true,
      sessionSampleRate: isBot() ? 0 : 100,
      beforeSend: (log) => {
        if (shouldBeDiscardedFromLogs(log)) {
          return false
        }

        return true
      },
    }

    logger.debug('init rum', rumConfig)
    datadogRum.init(rumConfig)

    logger.debug('init logs', logConfig)
    datadogLogs.init(logConfig)
  },
}
